<template>
    <div>

        <button-secondary @click="open">
            <template slot="icon"><i class="fa fa-pencil"></i></template>
            Bearbeiten
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>
                    zone bearbeiten
                </template>


                <loading v-show="loading"></loading>

                <div v-show="!loading">

                    <div class="flex justify-end">
                        <confirm-dialog @confirmed="removeGroup">
                            <button-delete>
                                <template v-slot:icon><i class="fa fa-trash"></i></template>
                                Zone löschen
                            </button-delete>
                            <template v-slot:header>Zone löschen</template>
                            <template v-slot:question>Soll die Zone wirklich gelöscht werden?</template>
                            <template v-slot:confirm>
                                <button-primary>
                                    <template slot="icon"><i class="fa fa-trash"></i></template>
                                    Zone löschen
                                </button-primary>
                            </template>
                        </confirm-dialog>
                    </div>

                    <input-text class="mb-2" v-model="name">
                        Name der Zone
                    </input-text>

                    <div class="grid grid-cols-1 gap-4">
                        <multi-select v-model="checkedDesks"
                                      :selectable="availableDesks">
                            <b>Schreibtische in der Zone</b>
                        </multi-select>

                        <multi-select v-model="checkedBookables"
                                      :selectable="availableBookables">
                            <b>Bookables in der Zone</b>
                        </multi-select>

                        <multi-select v-model="checkedConferenceRooms"
                                      :selectable="availableConferenceRooms">
                            <b>Konferenzräume in der Zone</b>
                        </multi-select>

                    </div>

                    <div class="flex justify-end">
                        <button-primary @click="save">
                            <template slot="icon"><i class="fa fa-save"></i></template>
                            Speichern
                        </button-primary>
                    </div>
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary";
import Modal from "./Modal";
import ButtonDelete from "./UI/ButtonDelete";
import Loading from "./UI/Loading";
import ConfirmDialog from "./UI/ConfirmDialog";
import InputText from "./UI/InputText";
import Navigation from "./Navigation";
import ButtonSecondary from "./UI/ButtonSecondary";
import MultiSelect from "./UI/MultiSelect.vue";

export default {
    name: "ZoneEdit",
    components: {
        ButtonDelete,
        ButtonPrimary,
        ButtonSecondary,
        ConfirmDialog,
        InputText,
        Loading,
        Modal,
        MultiSelect,
        Navigation,
    },

    props: ['id'],

    data: () => ({
        showModal: false,
        loading: false,
        name: '',
        mapLink: '',
        checkedDesks: [],
        availableDesks: [],
        checkedBookables: [],
        availableBookables: [],
        checkedConferenceRooms: [],
        availableConferenceRooms: [],
        zone: null,
    }),

    methods: {
        open() {
            this.showModal = true;
            this.load();
        },
        load() {
            this.loading = true;
            this.$http.get(`/admin/zones/${this.id}`)
                .then(result => {
                    this.name = result.data.data.name;
                    this.zone = result.data.data;
                    this.mapLink = result.data.data.map_link;
                    this.checkedDesks = result.data.data.desks.map((desk) => desk.id);
                    this.checkedBookables = result.data.data.bookables.map((bookable) => bookable.id);
                    this.checkedConferenceRooms = result.data.data.conference_rooms.map((conf) => conf.id);
                    this.loading = false;
                });
            this.$http.get('/admin/desks')
                .then(result => {
                    this.loading = false;
                    this.availableDesks = result.data.desks.map(e => ({text: e.name, id: e.id}));
                });
            this.$http.get('/admin/bookables')
                .then(result => {
                    this.loading = false;
                    this.availableBookables = result.data.data.map(b => ({text: b.name, id: b.id}));
                });
            this.$http.get('/admin/conference_rooms')
                .then(result => {
                    this.loading = false;
                    this.availableConferenceRooms = result.data.data.map(c => ({text: c.name, id: c.id}));
                });
        },
        save() {
            this.loading = true;
            this.$http
                .post(`/admin/zones/${this.id}`, {
                    _method: 'put',
                    name: this.name,
                    desks: this.checkedDesks,
                    bookables: this.checkedBookables,
                    conference_rooms: this.checkedConferenceRooms,
                })
                .then(() => {
                    this.loading = false;
                    this.showModal = false;
                    this.$emit('updated');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        handleFileUpload() {
            let map = this.$refs.map.files[0];
            let formData = new FormData();
            formData.append('map', map);
            formData.append('_method', 'put');
            this.$http
                .post(`/admin/zones/${this.id}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((response) => {
                    this.mapLink = response.data.data.map_link;
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
        removeMap() {
            this.loading = true;
            this.$http.post(`/admin/zones/${this.id}`, {
                _method: 'put',
                map: '',
            }).then(() => {
                this.loading = false;
                this.mapLink = null;
            }).catch(error => {
                this.$root.$emit('error', error);
            })
        },
        removeGroup() {
            this.loading = true;
            this.$http.post(`/admin/zones/${this.id}`, {
                _method: 'delete',
            }).then(() => {
                window.location.href = '/admin/pages/zones';
                this.loading = false;
                this.$emit('updated');
            }).catch(error => {
                this.loading = false;
                this.$emit('updated');
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
